module.exports = __webpack_public_path__ + "img/camera.1a211a9d.png";